
<template>
  <div class="currency">
    <div class="currency-pad" v-show="this.isApp == true ? false : true">
      <div class="conversion-con">
        <div class="conversion-top">
          <div class="conversion-title">{{ $t("buy.t31") }}</div>
          <div>
            <img
              class="conversion-img"
              src="../assets/index/tether_icon.png"
              alt=""
            />
          </div>
          <div>1{{ currencyList.currency }} = {{ratioList.rate}} {{ currencyList.myr }}</div>
        </div>
        <div>
          <span class="conversion-title">{{ $t("buy.t32") }}</span
          ><span>{{ ratioList.timestamp }}</span>
        </div>
        <div class="line"></div>
        <div class="conversion-currency">{{ $t("buy.t33") }}</div>
        <div class="biaoge">
          <div>
            <div>
              <span>{{ $t("buy.t33") }}</span
              ><span>({{ currencyList.currency }})</span>
            </div>
            <div>
              <input
                type="number"
                class="conversion-input"
                v-model="iscurrencyNum"
              />
            </div>
          </div>
          <div>
            <table class="tether_conversion_table">
              <tbody>
                <tr>
                  <th colspan="2">汇率金额</th>
                </tr>

                <tr>
                  <td class="USDToriCoin">USDT</td>
                  <td class="usdtTotal">{{ iscurrencyNum }}</td>
                </tr>

                <tr>
                  <td class="USDToriCoin">总额 (MYR)</td>
                  <td class="usdtTotal">{{ totalPrice }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div class="line"></div>

        <div class="payChoice-con">
          <div class="bank-options">{{ $t("buy.t18") }}</div>
          <div class="promotions-con">
            <img
              @click="choiceCry"
              :class="
                this.isCry == true ? 'promotions-img-sub' : 'promotions-img'
              "
              src="../assets/index/baifenzhi.png"
              alt=""
            />
          </div>
          <el-checkbox v-model="isagree"
            ><div class="czdetails-title">
              {{ $t("buy.t20") }}
            </div></el-checkbox
          >

          <div class="reminder-con">
              <div v-html="currencyList.reminder"></div>
          </div>



          <div class="btm-con">
            <button class="btm-reset" @click="submit">{{ $t("buy.t22") }}</button>
          </div>
        </div>
      </div>
    </div>

    <div class="currency-pad" v-show="this.isApp == false ? false : true">
      <div class="conversion-con">
        <div class="conversion-top">
          <div class="conversion-title">{{ $t("buy.t31") }}</div>
          <div>
            <img
              class="conversion-img"
              src="../assets/index/tether_icon.png"
              alt=""
            />
          </div>
          <div>1{{ currencyList.currency }} = {{ratioList.rate}} {{ currencyList.myr }}</div>
        </div>
        <div>
          <span class="conversion-title">{{ $t("buy.t32") }}</span
          ><span>{{ ratioList.timestamp }}</span>
        </div>
        <div class="line"></div>
        <div class="conversion-currency">{{ $t("buy.t33") }}</div>
        <div class="biaoge-h5">
          <div>
            <div>
              <span>{{ $t("buy.t33") }}</span
              ><span>({{ currencyList.currency }})</span>
            </div>
            <div>
              <input
                type="number"
                class="conversion-input"
                v-model="iscurrencyNum"
              />
            </div>
          </div>
          <div>
            <table class="tether_conversion_table">
              <tbody>
                <tr>
                  <th colspan="2">汇率金额</th>
                </tr>

                <tr>
                  <td class="USDToriCoin">USDT</td>
                  <td class="usdtTotal">{{ iscurrencyNum }}</td>
                </tr>

                <tr>
                  <td class="USDToriCoin">总额 (MYR)</td>
                  <td class="usdtTotal">{{ totalPrice }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div class="line"></div>

        <div class="payChoice-con">
          <div class="bank-options">{{ $t("buy.t18") }}</div>
          <div class="promotions-con">
            <img
              @click="choiceCry"
              :class="
                this.isCry == true ? 'promotions-img-sub-h5' : 'promotions-img-h5'
              "
              src="../assets/index/baifenzhi.png"
              alt=""
            />
          </div>
          <el-checkbox v-model="isagree"
            ><div class="czdetails-title">
              {{ $t("buy.t20") }}
            </div></el-checkbox
          >

          <div class="reminder-con">
              <div v-html="currencyList.reminder"></div>
          </div>



          <div class="btm-con">
            <button class="btm-reset" @click="submit">{{ $t("buy.t22") }}</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState, mapMutations } from "vuex";

export default {
  filters: {
    tofd(value) {
      return value.tofixed(2);
    },
  },
  data() {
    return {
      isagree: false,
      isCry: false,
      isnum: "1",
      iscurrencyNum: "",
      ratioList:{},
      currencyList: {
        currency: "USDT",
        myr: "(MYR)",
        reminder: `<div style="color: #ce9211;border: 0.0625rem solid #ce9211;font-size: small;">
                <p style="margin: 0.625rem 0.75rem;font-weight: bold;">Reminder:</p>
                <p style="margin-left: 1.5625rem;">1. USDT deposit method applies to all Royalewin members.</p>
                <p style="margin-left: 1.5625rem;">2. Please refer the following table for minimum USDT deposit, deposit below the amount may result in the loss of your deposit.</p>
                <table class="depositreminder" style="margin-left: 2.625rem;border: 0.0625rem solid white;border-collapse: collapse;">
                    <tbody><tr>
                        <th style="background-color: darkred;padding: 0.3125rem;border: 0.0625rem solid white;">Blockchain</th>
                        <th style="background-color: darkred;padding: 0.3125rem;border: 0.0625rem solid white;">Min Deposit</th>
                    </tr>
                    <tr>
                        <td style="padding: 0.3125rem;border: 0.0625rem solid white;">TRC20</td>
                        <td style="padding: 0.3125rem;border: 0.0625rem solid white;">USDT 10</td>
                    </tr>
                    <tr>
                        <td style="padding: 0.3125rem;border: 0.0625rem solid white;">ERC20</td>
                        <td style="padding: 0.3125rem;border: 0.0625rem solid white;">USDT 100</td>
                    </tr>
                </tbody></table>
                <p style="margin-left: 1.5625rem;">3. Please check the conversion rate before processing the transfer.</p>
                <p style="margin-left: 1.5625rem;">4. Please transfer according to the selected blockchain type. Transferring with any other coin or blockchain may result in the loss of your deposit.</p>
                <p style="margin-left: 1.5625rem;">5. The credit will be added after all network confirmed.</p>
                <p style="margin-left: 1.5625rem;">6. Please do not fill "Royalewin" or any sensitive words related to gambling as reference.</p>
            </div>`,
      },
    };
  },
  created() {
    this.getRatioList()
  },
  computed: {
    totalPrice() {
      let aa = this.iscurrencyNum * this.ratioList.rate;
      return aa.toFixed(2);
    },
    ...mapState({
      isApp(state) {
        return state.isApp;
      },
      tokenData(state){
        return state.tokenData;
      }
    }),
  },
  methods: {
    choiceCry() {
      this.isnum++;
      console.log("this.isnum", this.isnum);
      if (this.isnum % 2 == 0) {
        this.isCry = true;
      } else {
        this.isCry = false;
      }
    },
    submit() {
        alert('Not currently open~')
    },
    //获取汇率实时更新
    getRatioList() {
      var _that = this;
      let obj = {
        token:_that.tokenData
      };
      this.$FucPost(this.$store.state.ip + "/getCoinRate", obj)
        .then(function (res) {
          let resData = res
          // console.log("getRatioList-res", res);
          _that.ratioList = res
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
};
</script>

<style lang="less" scoped>
.currency {
  text-align: left;
  font-size: 0.9375rem;
  background-color: #1a1919d8;
}
.currency-pad {
  padding: 1.25rem;
}
.conversion-img {
  width: 1.4375rem;
  height: 1.4375rem;
}
.conversion-top {
  display: flex;
  align-items: center;
  margin-bottom: 1.25rem;
}
.conversion-title {
  margin-right: 0.3125rem;
}
.line {
  height: 0.125rem;
  border-bottom: 0.0625rem solid rgb(255, 196, 0);
  margin: 1.25rem 0;
}
.conversion-currency {
  color: #ccab40;
  font-weight: bold;
  font-size: 1rem;
  letter-spacing: 0.125rem;
  text-transform: uppercase;
  text-align: left;
  margin: 0.625rem 0;
}
.biaoge {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin: 0.625rem 0.3125rem;
}
.biaoge-h5{
    
}
.conversion-input {
  height: 1.5rem;
  padding: 0.3125rem;
  width: 11.3125rem;
  margin: 0.625rem 0;
  border-radius: 0.3125rem;
}
.tether_conversion_table {
  width: 40%;
  border: 0.0625rem solid #26a17b;
  border-collapse: collapse;
}
.tether_conversion_table th {
  padding: 0.3125rem 0.625rem;
  text-align: center;
  background-color: #26a17b;
}
.tether_conversion_table td {
  padding: 0.3125rem 0.625rem;
  border: 0.0625rem solid #26a17b;
}
.USDToriCoin {
  min-width: 6.25rem;
}
.usdtTotal {
  min-width: 6.25rem;
}
.promotions-img-h5 {
   width: 12.5rem;
    height: 2.8125rem;
  text-align: left;
  filter: grayscale(100%);
}
.promotions-img-sub-h5 {
   width: 12.5rem;
    height: 2.8125rem;
  text-align: left;
  border: 0.125rem solid #ce9211;
  border-radius: 0.625rem;
  filter: none;
}
.reminder-con{
    margin: 1.25rem 0;
}
/deep/ p{
    color: #ce9211;
}
</style>